export const InvoiceBillingValidation = (formData) => {
    const errors = {};
   
    if (!formData.vc_Title || formData.vc_Title==="") {
        errors.vc_Title = 'This field is required';
    }
    if (!formData.vc_Address1 || formData.vc_Address1==="") {
        errors.vc_Address1 = 'This field is required';
    }
    
    return errors;
};
